import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { Card, Button, Tabs, Badge } from 'antd';
import { connect } from 'kts-platform-frame/redux';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { history } from 'kts-platform-frame/routes';
import UIAdminMylist from './UI.Network.Admin.MyList';
import InviteTab from './UI.Invite';
import UIAdminPlatformlist from './UI.Network.Admin.PlatformList';
import UIAdminWaitingJoinlist from './UI.Network.Admin.WaitingJoinList';
import {
    PageHeaderTop,
} from 'kts-xui';
// import UIButtons from './UI.Network.Buttons';
import UISearch from './UI.Search';
const TabPane = Tabs.TabPane;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loading: {};
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loading: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentWillUnmount() {
        ModulesAction.hideAside();
    }
    componentDidMount() {
        ModulesAction.pageListWaitingJoinListAll();
    }

    render() {
        const tabskey = this.modulesState.tabchange;
        return (
            <div className="special">
                <PageHeaderTop
                    activeKey={this.modulesState.tabchange}
                    title="网络管理"
                    help="网络管理"
                    onChange={this.tabsOnChange}
                    // tabBarExtraContent={<div style={{ display: 'flex' }}><a onClick={this.gocompanyPublic}>访问公开首页</a></div>}
                    tabs={[
                        {
                            tab: <span><i className={`anticon anticon-wodewangluo rotate270 mr-5`}></i>我的网络</span>,
                            tabKey: '1'
                        },
                        {
                            tab: <span> <i className={`anticon anticon-pingtaiwangluo1 mr-5`}></i>邀请连接</span>,
                            tabKey: '2'
                        },
                        {
                            tab: <span className={css.watingbagecss}><i className={`anticon anticon-gongsi1 mr-5`}></i>待加入列表({this.modulesState.stateWaitingjoin.totalAcceptOrRefuse})</span>,
                            tabKey: '3'
                        },

                    ]}

                >
                </PageHeaderTop>
                {
                    tabskey === '1' && <>
                        {/* <UISearch tabskey={tabskey} loading={this.props.loading} /> */}
                        <UIAdminMylist loading={this.props.loading} />
                    </>
                }
                {
                    tabskey === '2' && <InviteTab />
                }
                {
                    tabskey === '3' && <UIAdminWaitingJoinlist loading={this.props.loading} />
                }
                {/* <Tabs 
                        defaultActiveKey={this.modulesState.tabchange} 
                        type="card"  
                        className={css.tabsmodules}
                        onChange={ModulesAction.onChangeTab}
                        tabBarExtraContent={
                            <div>
                            </div>
                        }
                    >
                        <TabPane tab={<span> <i className={`anticon anticon-wodewangluo rotate270 mr-5`}></i>我的网络</span>} key="1">
                            <UISearch tabskey={tabskey} loading={this.props.loading}/>
                            {tabskey === '1' && <UIAdminMylist loading={this.props.loading}/>}
                        </TabPane>
                        <TabPane tab={<span> <i className={`anticon anticon-pingtaiwangluo1 mr-5`}></i>平台网络</span>} key="2"> 
                            <UISearch tabskey={tabskey} loading={this.props.loading}/> 
                            {tabskey === '2' && <UIAdminPlatformlist loading={this.props.loading}/>} 
                        </TabPane>
                       
                        <TabPane tab={<span className={css.watingbagecss}><i className={`anticon anticon-gongsi1 mr-5`}></i>待加入列表({this.modulesState.stateWaitingjoin.totalAcceptOrRefuse})</span>} key="3" >
                        {tabskey === '3' && <UIAdminWaitingJoinlist loading={this.props.loading}/>}
                        </TabPane>
                    </Tabs>  */}
            </div>
        );
    }
    tabsOnChange = (key) => {
        // console.log(key,key === '/workbench/platform/companyinfo/qualification', 'sss');
        ModulesAction.onChangeTab(key);
        // history.push(key);
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.Admin.tsx